import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentRouteEntity } from '../../domain/entities/ShipmentRouteEntity'
import decodeCoordinates from '@/utils/decodeCoordinates'
import type { ShipmentRouteAdminDto } from '@/backend/market'

export class ShipmentRouteModel extends ShipmentRouteEntity {
  constructor(dataDto: ShipmentRouteAdminDto) {
    super()
    mapEntityProperties<ShipmentRouteEntity>(this, dataDto, {
      map: {
        route: decodeCoordinates(dataDto.route ?? '')
      }
    })
  }
}
